import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ShallowRenderedComponent from '../base/ShallowRenderedComponent';

class Loader extends ShallowRenderedComponent {

	static propTypes = {
		loading: PropTypes.bool,
		className: PropTypes.string
	};

	render() {
		const { loading, className } = this.props;
		if(!loading) {
			return null;
		}
		return (
			<div className={cx('loader-container', className)}>
				<div className='loading-bar indeterminate loading-blue' />
			</div>
		);
	}

}

export default Loader;
